import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
const STYLE_LINK = 'module-style-';
const PRELOAD_LINK = 'module-style-preload-';
@Injectable({
  providedIn: 'root'
})
export class StyleHelperService {
  previousId: {
    styleLinkElementId: string;
    preloadLinkElementId: string;
  };
  currentId: {
    styleLinkElementId: string;
    preloadLinkElementId: string;
  };

  constructor(@Inject(DOCUMENT) private document: Document) { }

  /**
   * Loads require style on runtime
   * created style link on the fly in head section of page,
   * if exist will replace passed style with the loaded one.
   *
   * @param styleName of the style chunk defined in angular.json
   */
  loadStyle(styleName: string): Observable<boolean> {
    return new Observable((observer) => {
      const head = this.document.getElementsByTagName('head')[0];
      this.currentId = {
        preloadLinkElementId: PRELOAD_LINK + styleName.split('.')[0],
        styleLinkElementId: STYLE_LINK + styleName.split('.')[0],
      };
      const preloadLink = document.createElement('link');
      preloadLink.id = this.currentId.preloadLinkElementId;
      preloadLink.href = `${styleName}`;
      preloadLink.rel = 'preload';
      preloadLink.as = 'style';
      head.appendChild(preloadLink);

      const preloadedStyle = document.createElement('link');
      preloadedStyle.id = this.currentId.styleLinkElementId;
      preloadedStyle.onload = () => {
        observer.next(true);
        observer.complete();
      };
      preloadedStyle.onerror = () => {
        console.log('stylenotloaded');
        observer.next(false);
        observer.complete();
      };
      preloadedStyle.rel = 'stylesheet';
      preloadedStyle.href = `${styleName}`;
      head.appendChild(preloadedStyle);
    });
  }

  removePreviousStyles() {
    if (this.previousId && this.currentId && this.previousId.styleLinkElementId !== this.currentId.styleLinkElementId) {
      const preloadLinkElement = <HTMLLinkElement>this.document.getElementById(this.previousId.preloadLinkElementId);
      const styleLinkElement = <HTMLLinkElement>this.document.getElementById(this.previousId.styleLinkElementId);
      if (styleLinkElement) {
        this.document.head.removeChild(preloadLinkElement);
        this.document.head.removeChild(styleLinkElement);
      }
    }
    this.previousId = JSON.parse(JSON.stringify(this.currentId));
  }
}
